import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import './style.scss';

const ContextBlockItem = ({ id, name, fields, isDisabled }) => (
  <div data-test={name} styleName="table-wrapper">
    <table styleName="table">
      <thead>
        <tr>
          <th colSpan="2" data-test="title">
            {name}
          </th>
        </tr>
      </thead>
      <tbody>
        {fields.map(field => (
          <tr key={field}>
            <td data-test={`${field}-label`}>{field}</td>
            <td>
              <Field
                autoComplete="foo-boo-foo-boo"
                component="input"
                data-test={`${field}-value`}
                disabled={isDisabled}
                name={`blocks.${id}.${field}`}
                // FIXME: That's the fix since Chrome warning inputs without
                // this attr and there is no way to disable it, autoComplete='off' doesn't work
                type="text"
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

ContextBlockItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(PropTypes.string),
  isDisabled: PropTypes.bool,
};

ContextBlockItem.defaultProps = {
  fields: [],
};

export default ContextBlockItem;
